import { Placemark, Polyline } from "@pbe/react-yandex-maps";
import React, { FC, useEffect, useState } from "react";
import { getMidPointArrow } from "./ArrowDirection";
import imgArrow from '../../../../assets/images/arrow-up-arrows-svgrepo-com.svg';
import { TRouteDirection } from "../../types/types";

const PolylineRoadmap: FC<IPolylineRoadmapProps> = ({ roadmapInfo, routeDirection }) => {
    const [opacity, setOpacity] = useState(1);
    const arrow = getMidPointArrow(roadmapInfo.coordinates);
  
    const colorLine = {
        'АВТОБУС': 'rgb(36, 205, 115)',
        'ТРАМВАЙ': 'rgb(255,0,0)',
    }

    useEffect(() => {
        const roadmapDirections = roadmapInfo.direction.toString() === '1' ? 'to' : 'from'
        console.log('roadmapDirections', roadmapDirections)
        if (routeDirection.includes(roadmapDirections)) {
            setOpacity(1)
        } else {
            setOpacity(0.3)
        }

    }, [roadmapInfo, routeDirection])

    const strokeStyle = {
        'АВТОБУС': 'solid',
        'ТРАМВАЙ': 'dash',
        '0': 'solid',
        '1': 'solid',
    }

    // const opacity = {
    //     'АВТОБУС': 0.8,
    //     'ТРАМВАЙ': 0.5,
    //     '0': 0.8,
    //     '1': 0.3,
    // }


    return (
        <>
            <Polyline
                geometry={roadmapInfo.coordinates}
                options={{
                    strokeColor: roadmapInfo.type ? colorLine[roadmapInfo.type.toUpperCase()] : 'rgb(36, 205, 115)',
                    strokeWidth: 7,
                    strokeOpacity: opacity,
                    strokeStyle: strokeStyle[roadmapInfo.direction.toString()] || 'solid',
                }}
            />
            {/* {arrow && (
                <Placemark
                    geometry={arrow.coords}
                    options={{
                        iconLayout: 'default#image',
                        iconImageHref: imgArrow, // стрелка вправо
                        iconImageSize: [20, 20],
                        //@ts-ignore
                        iconRotation: arrow.rotation,
                    }}
                />
            )} */}
        </>
    )
}

export default PolylineRoadmap;

export interface IPolylineRoadmapProps {
    roadmapInfo: IPolylineRoadmap,
    routeDirection: TRouteDirection[],
}

export interface IPolylineRoadmap {
    routeId: number | string, coordinates: number[][], type?: 'ТРАМВАЙ' | 'АВТОБУС', direction: string | number
}